import { SearchContext } from 'components/search/SearchContext';
import { SearchResultsPage } from 'components/search/SearchResultsPage';
import { core } from '@tock/coretypes';
import { getMetroAreas } from 'selectors/appSelector';
import { useActions } from '@tock/shared/utils/connect';
import { useCurrentMetroArea } from 'hooks/useCurrentMetroArea';
import { useRoutedCollectionPageInfo } from 'selectors/consumerPageSelectors';
import { useSelector } from 'react-redux';
import React from 'react';

const CollectionPageWidget: React.FunctionComponent = () => {
  const { actions } = useActions();
  const currentMetroArea = useCurrentMetroArea();
  const metroAreas = useSelector(getMetroAreas);
  const { metroArea: collectionMetroArea } = useRoutedCollectionPageInfo();

  // The user's metro area should only be set to the Collection's metro area upon first visit to the page.
  // This allows the user to change location from the Collection page, and have this change persist.
  // We're using this ref to track whether the metro area has already been set once
  const hasMetroAreaBeenSet = React.useRef<boolean>(false);

  // If Collection has a metro area that is different from the user's current metro area,
  // change the user's metro area to match
  React.useEffect(() => {
    if (collectionMetroArea?.slug !== currentMetroArea?.slug && !hasMetroAreaBeenSet.current) {
      const newMetroArea = (metroAreas as core.MetroArea[]).find(
        (m) => m.slug === collectionMetroArea?.slug
      );
      newMetroArea && actions.metroArea.selectMetroArea(newMetroArea);
      hasMetroAreaBeenSet.current = true;
    }
  }, [actions.metroArea, collectionMetroArea, currentMetroArea, hasMetroAreaBeenSet, metroAreas]);

  return (
    <SearchContext
      locale={currentMetroArea?.locale}
      currencyCode={currentMetroArea?.currencyCode}
      type="collectionPage"
    >
      <SearchResultsPage />
    </SearchContext>
  );
};

export default CollectionPageWidget;
